import SearchInput from "@/views/service-center/components/service-main/search-input";
import VendorItem from "@/views/service-center/search/components/service-search-main/vendor-item";
import { useServiceCenterSearchData } from "@/views/service-center/search/hooks/useServiceCenterSearchData";
import { useCallback, useEffect, useState } from "react";
import S from "./index.module.scss";
import Pager from "@/components/entities/pager";
import { useStore } from "@/hooks/system/useStore";
import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

const ServiceSearchMain = () => {
  const t = useTranslations();
  const [searchValue, setSearchValue] = useState("");
  const { selectedInstructionFilters, setSelectedInstructionFilters } = useStore("search");

  const {
    serviceCenterSearch: { serviceCenterSearch, loading: serviceCenterSearchLoading },
  } = useServiceCenterSearchData();

  useEffect(() => {
    setSearchValue(selectedInstructionFilters.q ?? "");
  }, [selectedInstructionFilters]);

  const pageHandler = (page: number) => {
    setSelectedInstructionFilters({ pageNumber: page });
  };

  const handleSearchSubmit = useCallback(() => {
    setSelectedInstructionFilters({ q: searchValue.trim(), pageNumber: 1 });
  }, [searchValue, setSelectedInstructionFilters]);

  if (!serviceCenterSearch || serviceCenterSearchLoading) return <></>;

  return (
    <div className={S.contentWrap}>
      <div className={S.searchWrapper}>
        <SearchInput
          placeholder={t("findByArticle")}
          $variant="black"
          value={searchValue}
          onChange={setSearchValue}
          onSubmit={handleSearchSubmit}
        />
      </div>
      {serviceCenterSearch.total ? (
        <>
          <div className={S.vendorsGrid}>
            {(serviceCenterSearch.instructions ?? []).map((vendor, idx) => (
              <VendorItem vendor={vendor} key={idx} />
            ))}
          </div>
          <Pager
            activePageNumber={selectedInstructionFilters.pageNumber || 1}
            total={serviceCenterSearch.total}
            activePageSize={20}
            onPageChangeHandler={pageHandler}
          />
        </>
      ) : (
        <p className={S.notFoundText}>{t("noResults", { query: selectedInstructionFilters.q || "" })}</p>
      )}
    </div>
  );
};

export default observer(ServiceSearchMain);
